import { render, staticRenderFns } from "./HeadNav.vue?vue&type=template&id=4bd6768f&scoped=true&"
import script from "./HeadNav.vue?vue&type=script&lang=js&"
export * from "./HeadNav.vue?vue&type=script&lang=js&"
import style0 from "./HeadNav.vue?vue&type=style&index=0&id=4bd6768f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd6768f",
  null
  
)

export default component.exports